// app/javascript/controllers/ats_preview_tabs_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "jdScoreChip"]
  static values  = { active: { type: String, default: "resume" } }

  connect() { this.#apply() }

  switchTab(event) {
    const tab = event.currentTarget.dataset.tab
    if (tab) this.activeValue = tab
  }

  activeValueChanged() { this.#apply() }

  onKeydown(event) {
    if (!["ArrowLeft", "ArrowRight"].includes(event.key)) return
    const tabs = this.tabTargets
    const idx = tabs.findIndex(t => t.dataset.tab === this.activeValue)
    if (idx < 0) return
    const next = event.key === "ArrowRight"
      ? tabs[(idx + 1) % tabs.length]
      : tabs[(idx - 1 + tabs.length) % tabs.length]
    next.focus()
    this.activeValue = next.dataset.tab
    event.preventDefault()
  }

  setJdScore(rate) {
    if (!this.hasJdScoreChipTarget) return
    if (rate == null) {
      this.jdScoreChipTarget.classList.add("hidden")
      this.jdScoreChipTarget.textContent = ""
      return
    }
    const pct = Math.round(rate * 100)
    this.jdScoreChipTarget.textContent = `${pct}%`
    this.jdScoreChipTarget.classList.remove("hidden",
      "bg-primary-fixed", "text-on-primary-fixed",
      "bg-error-container", "text-on-error-container",
      "bg-primary", "text-on-primary"
    )
    if (rate >= 0.80) {
      this.jdScoreChipTarget.classList.add("bg-primary", "text-on-primary")
    } else if (rate >= 0.50) {
      this.jdScoreChipTarget.classList.add("bg-primary-fixed", "text-on-primary-fixed")
    } else {
      this.jdScoreChipTarget.classList.add("bg-error-container", "text-on-error-container")
    }
  }

  #apply() {
    for (const t of this.tabTargets) {
      const on = t.dataset.tab === this.activeValue
      t.classList.toggle("is-active", on)
      t.setAttribute("aria-selected", on ? "true" : "false")
    }
    for (const p of this.panelTargets) {
      p.classList.toggle("hidden", p.dataset.tab !== this.activeValue)
    }
  }
}
